import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaMineralApi = createApi({
    reducerPath: "core/measurement/mineral",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementMineralList"],
    endpoints: (builder) =>({
        measurementMineralFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementMineralList'],
            query: (query = '') => ({
                url: "core/measurement/mineral" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementMineralCreate: builder.mutation({
            invalidatesTags: ['measurementMineralList'],
            query: (data)=>({url: "core/measurement/mineral", method: "POST", data})
        }),
        measurementMineralUpdate: builder.mutation({
            invalidatesTags: ['measurementMineralList'],
            query: (data)=>({url: "/core/measurement/mineral/"+data.id, method: "PUT", data})
        }),
        measurementMineralDelete: builder.mutation({
            invalidatesTags: ['measurementMineralList'],
            query: (id)=>({url: "/core/measurement/mineral/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementMineralFindAllQuery, useMeasurementMineralCreateMutation, useMeasurementMineralUpdateMutation, useMeasurementMineralDeleteMutation } = meaMineralApi;
export {meaMineralApi};
